import './App.css';



//composants
import Home from './Home';
import Real from '../src/components/Pages/Real/Real';
import Manga from '../src/components/Pages/Manga/Manga';
import Autres from '../src/components/Pages/Autres/Autres';
import Jap from '../src/components/Pages/Jap/Jap';
import Dessins from '../src/components/Pages/Dessins/Dessins';
import Zoom from '../src/components/Pages/Zoom/Zoom';
import Error from '../src/components/Error/Error';

import Loader from '../src/components/Loader/Loader';

// import Logged from '../src/components/Login/Logged/Logged';




import { useContext } from 'react';
import {Routes, Route} from 'react-router-dom';
import {UserContext} from './context/userContext';


function App() {



  const {
    loader,
    mangaDatas,
    japDatas,
    autresDatas,
    realDatas,
    dessinsDatas

  } = useContext(UserContext);

  return loader ? (

    <Loader />
  )
  :
  (

    <div className="App"> 


    
       <Routes>
        <Route path='/' element={<Home />} />
        {/* <Route path='/logged/:id' element={<Logged />}/> */}
       

        {/* PAGES  */}

        <Route path='/real' element={<Real datas={realDatas} loader={loader}/>} />
        <Route path='/real/zoom/:id' element={<Zoom datas={realDatas}  />} />

        <Route path='/manga' element={<Manga datas={mangaDatas} loader={loader} />} />
        <Route path='/manga/zoom/:id' element={<Zoom datas={mangaDatas} />} />

        <Route path='/autres' element={<Autres datas={autresDatas} loader={loader} />} />
        <Route path='/autres/zoom/:id' element={<Zoom datas={autresDatas} />} />

        <Route path='/jap' element={<Jap datas={japDatas} loader={loader} />} />
        <Route path='/jap/zoom/:id' element={<Zoom datas={japDatas} />} />

        <Route path='/draw' element={<Dessins datas={dessinsDatas} loader={loader} />} />
        <Route path='/draw/zoom/:id' element={<Zoom datas={dessinsDatas} />} />

     

        {/* ERREUR */}

        <Route path='*' element={<Error />} />
       </Routes>
      
       

  
    </div>
   
  );
}

export default App;
